import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Box, Flex, Text } from '@radix-ui/themes';
import { CheckCircle2, LogIn, MailCheck, XCircle } from 'lucide-react';
import loginLogo from '../../assets/Luka-Healthcare.png';
import signImage from '../../assets/sign-image.svg';
import logoIMCAS from '../../assets/imacs_logo.svg';

const EmailConfirmationResult = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const message = searchParams.get('message');
  const isSuccess = status !== 'error';

  const title = isSuccess ? 'Email Confirmed' : 'Email Confirmation Failed';
  const fallbackMessage = isSuccess
    ? 'Your email has been confirmed successfully. Your login credentials have been sent to your email.'
    : 'We could not confirm your email. Please request a new confirmation link or contact your administrator.';

  return (
    <Flex direction="row" className="min-h-screen w-screen bg-white">
      <Box className="hidden h-screen bg-[#ecf2f1] w-[41.5%] lg:block">
        <Flex gap="6" direction="column" align="center" className="h-full">
          <img className="w-[70%] my-24" src={loginLogo} alt="" />
          <img className="w-[88%] mt-0" src={signImage} alt="" />
        </Flex>
      </Box>

      <Box className="w-full lg:w-[59.5%]">
        <Flex direction="column" align="center" justify="center" className="min-h-screen px-6 py-10">
          <div className="w-full max-w-[420px]">
            <img width="300" className="mb-8" src={logoIMCAS} alt="" />

            <div
              className={`mb-6 rounded-lg border p-6 ${
                isSuccess
                  ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
                  : 'border-red-200 bg-red-50 text-red-700'
              }`}
            >
              <div className="mb-5 flex items-center gap-3">
                {isSuccess ? (
                  <CheckCircle2 size={38} strokeWidth={1.8} />
                ) : (
                  <XCircle size={38} strokeWidth={1.8} />
                )}
                <Text size="6" weight="bold" className="block">
                  {title}
                </Text>
              </div>

              <Flex align="start" gap="3">
                <MailCheck size={22} strokeWidth={1.8} className="mt-1 flex-shrink-0" />
                <Text size="3" className="leading-6">
                  {message || fallbackMessage}
                </Text>
              </Flex>
            </div>

            <Link
              to="/auth/login"
              className="flex w-full items-center justify-center gap-2 rounded-sm bg-[#0b5a97] px-4 py-3 font-medium text-white shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <LogIn size={18} strokeWidth={2} />
              Go to Login
            </Link>
          </div>
        </Flex>
      </Box>
    </Flex>
  );
};

export default EmailConfirmationResult;
